module.exports = __webpack_public_path__ + "static/media/messages.8c877cf0.jpg";